import { TableCell, TableRow } from "@mui/material"
import LoadingButton from '@mui/lab/LoadingButton';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../../../../Apis";
import Swal from "sweetalert2";

export const PostErrorItem = ({ post, no, cookie, updatePostError, index }) => {
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const rePublish = () => {
    setLoading(true);
    const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + cookie
      },
      body: JSON.stringify({
        post_id: post.id
      })
    };
    fetch(api.re_publish_post + `?lang=${i18n.language}`, requestOptions)
    .then(res => res.json())
    .then(
        (result) => {
            setLoading(false)
            if (result.success) {
              updatePostError(index)
              Swal.fire(result.message, "", "success");
            } else {
              Swal.fire(result.message, "", "warning")
            }
        } 
    )
  }

  return (
    <TableRow>
      <TableCell>{no}</TableCell>
      <TableCell>{post?.user_fanpage?.fanpage_name}</TableCell>
      <TableCell sx={{ wordWrap: "break-word", whiteSpace: "normal" }}>
        <a href={`https://facebook.com/${post.post_id}`} target="_blank">{post.post_id}</a>
      </TableCell>
      <TableCell sx={{ wordWrap: "break-word", whiteSpace: "normal" }}>{post.log_publish}</TableCell>
      <TableCell>
        {
          post.is_publish_error ? (
            <LoadingButton variant="contained" className="text-transform" onClick={rePublish} loading={loading} type="button">
              {t("post.table.re_publish_button")}
            </LoadingButton>
          )
          :
          <></>
        }
      </TableCell>
    </TableRow>
  )
}